export default __webpack_public_path__ + "static/media/noun-overall.00f0b2c0.svg";